import { tv } from "../../../../node_modules/.pnpm/tailwind-variants@3.2.2_tailwind-merge@3.3.0_tailwindcss@4.1.8/node_modules/tailwind-variants/dist/index.js";
const checkboxVariants = tv(
  {
    base: `
      peer shrink-0 rounded-sm bg-(--white) transition-all
      focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2
      border border-(--gray-border-2) dark:border-(--gray-border-3) hover:border-(--gray-border-3) dark:hover:border-(--gray-primary-1)
      focus-visible:border-(--gray-primary-1) active:border-(--gray-primary-1)
      data-[state=checked]:bg-(--primary-2) data-[state=checked]:border-transparent data-[state=checked]:text-(--white)
      data-[state=indeterminate]:border-(--border-2) data-[state=indeterminate]:hover:border-(--border-3)
      data-[state=indeterminate]:bg-(--tag-1) data-[state=indeterminate]:text-(--text-1)
      disabled:cursor-not-allowed disabled:border-(--gray-border-1) disabled:bg-(--gray-tag-1) disabled:text-(--gray-border-3)
      disabled:data-[state=checked]:border-(--gray-border-1) disabled:data-[state=checked]:bg-(--gray-tag-1) disabled:data-[state=checked]:text-(--gray-border-3)
      disabled:data-[state=indeterminate]:border-(--gray-border-1) disabled:data-[state=indeterminate]:hover:border-(--gray-border-1)
      disabled:data-[state=indeterminate]:bg-(--gray-tag-1) disabled:data-[state=indeterminate]:text-(--gray-border-3)
    `,
    variants: {
      size: {
        sm: "size-3.5",
        default: "size-4",
        lg: "size-5"
      }
    },
    defaultVariants: {
      size: "default"
    }
  }
);
export {
  checkboxVariants
};
//# sourceMappingURL=index.js.map
